<template>
    <div class="sa-free-page" style="height: 100%">
        <div class="sa-free-page-header">
            <div style="width: 100%; display: flex; justify-content: center">
                <b-alert :show="filtro.idPresidio == null || filtro.area == null" variant="warning" style="width: 50%"> Selezionare Presidio e Area</b-alert>
            </div>
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <!-- <b-col cols="2">
            <label>Struttura</label>
            <b-form-select v-model="filtro.idStruttura" :options="aree" text-field="nome" value-field="nome">
              <template #first>
                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
          </b-col> -->
                    <b-col cols="3">
                        <label>Presidio</label>
                        <b-form-select v-model="filtro.idPresidio" :options="presidiOptions" text-field="text" value-field="value" :disabled="true"> </b-form-select>
                    </b-col>

                    <b-col cols="3">
                        <label>Identificativo</label>
                        <b-form-input v-model="filtro.identificativo"></b-form-input>
                    </b-col>
                    <b-col cols="3">
                        <label>Area</label>
                        <b-form-select v-model="filtro.area" :options="aree" text-field="text" value-field="value"> </b-form-select>
                    </b-col>
                    <b-col cols="3">
                        <label>Piano</label>
                        <b-form-select v-model="filtro.idPiano" :options="pianiOptions" text-field="nome" value-field="id"> </b-form-select>
                    </b-col>
                    <b-col cols="4">
                        <label>Cognome</label>
                        <b-form-input v-model="filtro.cognome"></b-form-input>
                    </b-col>
                    <b-col cols="4">
                        <label>Nome</label>
                        <b-form-input v-model="filtro.nome"></b-form-input>
                    </b-col>
                    <b-col cols="4" class="justify-content-end">
                        <label>Eseguite / Non Eseguite</label>
                        <b-form-checkbox v-model="filtro.eseguita" name="isAttivitaSvolte" switch></b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" :disabled="filtro.idPresidio == null || filtro.area == null" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <div class="sa-free-page-body">
            <b-row class="px-2">
                <b-col v-for="(value, key) of pazientiVisible" :key="key" cols="12" md="6" lg="4" class="mb-3">
                    <b-card header-tag="header" footer-tag="footer" class="h-100" v-if="getPrestazioni(key, value).length >= 1">
                        <template #header>
                            <b-row class="align-items-start mb-2" style="padding: 5px; min-height: 70px">
                                <b-col cols="2" class="d-flex align-items-start justify-content-start">
                                    <div @click="onClickAvatar(key)" style="cursor: pointer">
                                        <i class="fas fa-user-circle fa-3x"></i>
                                    </div>
                                </b-col>
                                <b-col cols="8" class="d-flex align-items-center justify-content-center">
                                    <b-badge show style="background-color: #74bce5; color: white; font-size: 1.1rem; padding: 1.2rem 1.2rem; line-height: 1.3; display: inline-block; min-width: 140px; text-align: center; border-radius: 12px">
                                        <div>{{ value.info.cognome }}</div>
                                        <div>{{ value.info.nome }}</div>
                                    </b-badge>
                                </b-col>

                                <b-col cols="2" class="d-flex justify-content-end align-items-start">
                                    <b-button size="sm" variant="outline-success" @click="onClickAttivitaExtra(key)">
                                        <i class="fas fa-plus"></i>
                                    </b-button>
                                </b-col>

                                <b-col cols="12" class="text-center mt-2">
                                    <h5 class="mb-0">
                                        <b-badge size="lg" style="background-color: #74bce5; color: white; font-size: 1rem; padding: 0.8rem 1rem; border-radius: 1rem">
                                            {{ getDataFormattata(value.info.dataNascita) }}
                                        </b-badge>
                                    </h5>
                                </b-col>
                            </b-row>
                        </template>

                        <b-card-text style="height: 220px; overflow-y: auto; overflow-x: hidden">
                            <b-row>
                                <b-col cols="12" v-for="(valore, chiave) in getPrestazioni(key, value)" :key="chiave" class="border rounded mb-2" style="border-color: red">
                                    <b-row class="py-1 px-2 align-items-center">
                                        <b-col cols="12" class="d-flex align-items-start">
                                            <span v-html="valore.dettaglio" v-if="filtro.area == 'SOMMINISTRAZIONE TERAPEUTICA'" class="mr-2 ft-style-span" :title="valore.dose + valore.dettaglio" :style="{ backgroundColor: getColorSection(valore) }"> </span>

                                            <span v-else class="mr-2 ft-style-span" :title="valore.nomeAttivita" :style="{ backgroundColor: getColorSection(valore) }">
                                                {{ valore.nomeAttivita }}
                                            </span>
                                        </b-col>

                                        <!-- <b-col cols="12" class="d-flex justify-content-center align-items-center">
                   
                    </b-col> -->

                                        <b-col class="d-flex justify-content-end align-items-center">
                                            <span style="margin-right: 10px"> {{ getDataOraFormattata(valore.dataOraProgrammata) }}</span>
                                            <template v-if="checkVisible('PROGRAMMATA', valore, 'ESEGUI')">
                                                <b-button v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Esegui Attività" @click="onClickEseguiAttivita(valore, true)" class="mr-1 no-text"> <b-icon icon="check"></b-icon></b-button>
                                            </template>
                                            <b-button v-if="checkVisible('PROGRAMMATA', valore, 'NO_ESEGUI')" v-b-tooltip.hover size="sm" variant="outline-danger" title="Annulla" :disabled="filterAttivitaSvolte" @click="onClickEseguiAttivita(valore, false)" class="mr-1">
                                                <i class="far fa-times-circle"></i>
                                            </b-button>
                                            <template v-if="checkVisible('PROGRAMMATA', valore, 'ESEGUI_FORM')">
                                                <b-button v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Compila Scheda" @click="onClickEseguiAttivita(valore, true)" class="mr-1 no-text">
                                                    <i class="fas fa-tasks"></i>
                                                </b-button>
                                            </template>
                                            <template v-if="checkVisible('PROGRAMMATA', valore, 'NO_ESEGUI_FORM')">
                                                <b-button v-b-tooltip.hover size="sm" variant="outline-danger no-text" title="Non Eseguita" @click="onClickEseguiAttivita(valore, false)" class="mr-1 no-text">
                                                    <i class="far fa-times-circle"></i>
                                                </b-button>
                                            </template>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-card>
                </b-col>
            </b-row>

            <div class="sa-free-page-footer">
                <modal-loading ref="cmpModalLoading"></modal-loading>
            </div>
        </div>

        <rsa-aree-pianificazione-edit-component ref="cmpRsaAreePianificazioneEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-pianificazione-edit-component>
        <rsa-aree-esegui-attivita-edit-component ref="cmpRsaAreeEseguiAttivitaEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-esegui-attivita-edit-component>
        <b-modal :title="dynamicJsonData.titolo" ref="mdlDynamicForm" size="lg" @shown="onShownDynamicForm" @ok="onOkDynamicForm" scrollable>
            <dynamic-form ref="cmpDynamicForm" :jsonData="dynamicJsonData" :isView="false"></dynamic-form>
        </b-modal>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import moment from "moment";

import RsaAreePianificazioneEditComponent from "../../rsagestioneospiti/components/RsaAreePianificazioneEditComponent.vue";
import RsaAreeEseguiAttivitaEditComponent from "../../rsagestioneospiti/components/RsaAreeEseguiAttivitaEditComponent.vue";
import axios from "axios";
import DynamicForm from "../../../utility/components/DynamicForm.vue";
import ModalLoading from "../../../../template/components/modal/components/ModalLoading.vue";

export default {
    mixins: [UtilityMixin],
    components: {
        ModalLoading,
        RsaAreePianificazioneEditComponent,
        RsaAreeEseguiAttivitaEditComponent,
        DynamicForm,
    },
    computed: {
        pazientiVisible() {
            for (let item in this.pazienti) {
                if (this.pazienti[item][this.filtro.area]) {
                    if (!this.pazienti[item][this.filtro.area].some((item) => item.stato === "PROGRAMMATA")) {
                        this.$delete(this.pazienti, item);
                    }
                } else {
                    this.$delete(this.pazienti, item);
                }
            }
            return this.pazienti;
        },
    },
    data() {
        return {
            page: 1,
            filterAttivitaSvolte: false,
            perPage: 6,
            totalRow: 0,
            filterIdentificativo: "",
            pathResourceUtentiPresidi: "/utentipresidi",
            key: 0,
            area: null,
            isNotData: false,
            selectedArea: null,
            pathResource: "/rsaattivitapazienteschedulazioni/schedulerall",
            pathResourceArea: "/rsaaree",
            pathResourceDynamicForm: "/dynamicform",
            pathResourcePiani: "/rsapostilettopiani",
            pathResourceDynamicFormData: null,
            items: [],
            dynamicJsonData: {},
            pazienti: {},
            filtro: {
                identificativo: null,
                idStruttura: null,
                idPresidio: null,
                cognome: null,
                nome: null,
                area: null,
                eseguita: false,
                idPiano: null,
            },
            presidiOptions: [],
            pazientiAllTmp: {},
            aree: [],
            attivitaSelezionata: null,
            idPresidio: null,
            presidio: {},
            pianiOptions: [],
        };
    },
    mounted() {
        let me = this;
        this.loadUserData();
        this.loadDataArea();

        me.filtro = {
            identificativo: null,
            idStruttura: null,
            idPresidio: null,
            cognome: null,
            nome: null,
            area: null,
            eseguita: false,
            idPiano: null,
        };
        if (localStorage.getItem("presidio")) {
            me.presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
            me.idPresidio = me.presidio ? me.presidio.idPresidio : null;
            me.filtro.idPresidio = me.idPresidio;
        } else {
            me.idPresidio = null;
        }
        me.loadPiani();
    },
    watch: {
        "filtro.eseguita": function (params) {
            let me = this;
            me.filterAttivitaSvolte = params;
        },
    },
    methods: {
        checkVisible(stato, item, operazione) {
            let returnValue = false;
            if (item.stato === stato) {
                if (item.idForm && operazione === "ESEGUI_FORM") {
                    returnValue = true;
                } else if (item.idForm && operazione === "NO_ESEGUI_FORM") {
                    returnValue = true;
                } else if (!item.idForm && operazione === "ESEGUI") {
                    returnValue = true;
                }
            } else if (stato === "INFO" && item.stato !== "PROGRAMMATA") {
                returnValue = true;
            } else if (stato === "INFO" && (item.stato == "EROGATA" || item.stato == "NON EROGATA")) {
                returnValue = true;
            }
            return returnValue;
        },
        onReset() {
            let me = this;
            me.filtro = {
                idPresidio: me.idPresidio,
                area: null,
                identificativo: null,
                cognome: null,
                nome: null,
                idPiano: null,
            };
            me.loadUtentiPresidi();
        },
        onSubmit() {
            let me = this;
            me.loadSchedulerForArea();
        },
        onClickAvatar(key) {
            if (key) {
                let paziente = this.pazienti[key];
                if (paziente) {
                    this.$router.push("/rsapaziente/view/" + paziente.info.id);
                }
            }
        },
        loadSchedulerForArea() {
            let me = this;
            me.$refs.cmpModalLoading.show();
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadSchedulerForAreaSuccess, me.loadSchedulerForAreaError);
        },
        loadSchedulerForAreaSuccess(response) {
            let me = this;
            let items = response.data.data;
            me.setPazientiAttivita(items);
            me.$bvToast.toast("Caricamento Avvenuto con Successo", {
                title: "Successo",
                variant: "success",
                autoHideDelay: 1500,
                solid: true,
            });
            me.$refs.cmpModalLoading.close();
        },
        loadSchedulerForAreaError(error) {
            console.log(error);
            let me = this;
            me.$refs.cmpModalLoading.close();
        },
        onShownDynamicForm() {
            //let me = this;
            //me.$refs.cmpDynamicForm.setForm(me.defaultValues);
        },
        loadUserData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/users/profile";
            axios
                .get(link)
                .then((response) => {
                    me.utente = response.data.data;
                    me.user = me.utente;
                    me.nominativoUtente = me.utente.lastname + " " + me.utente.firstname;
                    me.ruolo = me.utente.profilo;
                    me.loadUtentiPresidi(me.utente.id);
                })
                .catch((e) => {
                    //                    this.errors.push(e);
                    console.log(e);
                });
        },
        loadUtentiPresidi(id) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceUtentiPresidi, { idUtente: id }, me.resulResponseUtentiPresidi, me.resulErrorUtentiPresidi);
        },
        resulResponseUtentiPresidi(response) {
            let me = this;
            me.presidiOptions = [];
            if (response.data.data.list.length === 1) {
                me.filtro.idPresidio = response.data.data.list[0].idPresidio;
                me.presidiOptions.push({ text: response.data.data.list[0].denominazionePresidio, value: response.data.data.list[0].idPresidio });
            } else {
                response.data.data.list.forEach((element) => {
                    me.presidiOptions.push({ text: element.denominazionePresidio, value: element.idPresidio });
                });
            }
            me.presidiOptions.unshift({ text: "- Seleziona Presidio -", value: null });

            //loadData ?
        },
        resulErrorUtentiPresidi(error) {
            console.log(error);
        },

        onOkDynamicForm(bvModalEvent) {
            let me = this;
            if (me.isDynamicFormView) {
                me.$refs.mdlDynamicForm.hide();
            } else {
                let responseJsonData = this.$refs.cmpDynamicForm.getJsonData();
                responseJsonData.idAccettazione = me.attivitaSelezionata.idAccettazione;
                responseJsonData.idPaziente = me.attivitaSelezionata.idPaziente;
                responseJsonData.dataOraPrevista = me.attivitaSelezionata.dataOraPrevista;
                responseJsonData.dataOraEffettuata = me.attivitaSelezionata.dataOra;
                responseJsonData.dataOra = me.attivitaSelezionata.dataOra;
                responseJsonData.idRsaAttivitaPazienteSchedulazione = me.attivitaSelezionata.idRsaAttivitaPazienteSchedulazione;
                responseJsonData.nomeAttivita = me.attivitaSelezionata.nomeAttivita;
                responseJsonData.dettaglio = me.attivitaSelezionata.dettaglio;
                responseJsonData.indicazioni = me.attivitaSelezionata.indicazioni;
                responseJsonData.idAttivita = me.attivitaSelezionata.idAttivita;
                responseJsonData.idForm = me.dynamicJsonData.id;
                responseJsonData.dataOra = new Date().getTime();
                responseJsonData.note = " ";
                // responseJsonData.tipoRiga = "ORDINARIA";
                delete responseJsonData.ospite;
                delete responseJsonData.dataNascita;
                delete responseJsonData.educatore;
                delete responseJsonData.numero;
                //delete responseJsonData.dataOra;
                bvModalEvent.preventDefault();
                me.creaAttivita(responseJsonData);
            }
        },
        creaAttivita(responseJsonData) {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourceDynamicFormData;
            axios
                .post(link, responseJsonData)
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.$refs.mdlDynamicForm.hide();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = "Errore non gestito";
                    if (error.response) {
                        if (error.response.data.messaggio) {
                            messaggio = error.response.data.messaggio;
                        } else {
                            messaggio = error.response.data;
                        }
                    }
                    this.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerBgVariant: "danger",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            err;
                        });
                });
            this.$nextTick(() => {
                me.onSubmit();
            });
        },
        onClickEseguiAttivita(item, esito) {
            let me = this;
            let returnValue = esito ? "ESEGUITA" : "NON ESEGUITA";
            me.attivitaSelezionata = item;
            if (item.idForm && esito) {
                UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + item.idForm, {}, me.loadDynamicFormSuccess, me.loadDynamicFormError);
            } else {
                if (item.rsaAttivitaPazienteBean === null) {
                    item.dataOraEffettuata = new Date().getTime();
                }
                me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(item, returnValue);
            }
            this.$nextTick(() => {
                me.onSubmit();
            });
        },
        loadDynamicFormSuccess(response) {
            let me = this;
            let dynamicJsonData = response.data.data;
            dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
            me.dynamicJsonData = dynamicJsonData;
            me.pathResourceDynamicFormData = dynamicJsonData.pathModule;
            me.$refs.mdlDynamicForm.show();
        },
        loadDynamicFormError(error) {
            console.log(error);
        },
        onAfterSaveRequestRsaAreePianificazioneComponent() {
            let me = this;
            me.loadDataArea();
            me.onSubmit();
        },
        getPrestazioni(key, array) {
            let me = this;
            let prestazioni = array[this.filtro.area];
            let result = {};
            if (prestazioni) {
                if (!me.filterAttivitaSvolte) {
                    result = prestazioni.filter((e) => e.stato == "PROGRAMMATA");
                } else {
                    result = prestazioni.filter((e) => e.stato != "PROGRAMMATA");
                }
            }
            return result;
        },

        getColorSection(value) {
            let color = "rgba(255, 247, 173, 0.98)";
            switch (value.stato) {
                case "ESEGUITA":
                    color = "#2CC28E";
                    break;
                case "NON ESEGUITA":
                    color = "#FEC2C2";
                    break;

                default:
                    break;
            }
            return color;
        },

        getDataFormattata(date) {
            let data = moment(date).format("DD/MM/YYYY");
            return data;
        },
        getDataOraFormattata(date) {
            let data = moment(date).format("HH:mm");
            return data;
        },

        onChangeAreaSelected(value) {
            console.log(value);
        },
        setPazientiAttivita(items) {
            let pazienti = {};
            for (let item of items) {
                if (item.identificativo) {
                    if (pazienti[item.identificativo]) {
                        if (!pazienti[item.identificativo][item.area]) {
                            pazienti[item.identificativo][item.area] = [];
                        }
                        pazienti[item.identificativo][item.area].push(item);
                    } else {
                        pazienti[item.identificativo] = {
                            info: {
                                nome: item.nome,
                                cognome: item.cognome,
                                id: item.idPaziente,
                                idAccettazione: item.idAccettazione,
                                dataNascita: item.dataNascita,
                            },
                        };
                        if (!pazienti[item.identificativo][item.area]) {
                            pazienti[item.identificativo][item.area] = [];
                        }
                        pazienti[item.identificativo][item.area].push(item);
                    }
                }
            }
            this.pazienti = pazienti;
        },

        loadDataArea() {
            let me = this;
            me.loadDataResources(me.pathResourceArea, {}, me.loadDataAreaSuccess, me.loadDataAreaError);
        },
        loadDataAreaSuccess(response) {
            let me = this;
            me.aree = [];
            for (let item of response.data.data.list) {
                me.aree.push({ text: item.nome, id: item.id, value: item.nome });
            }
            if (me.aree.length === 1) {
                me.area = me.aree[0].nome;
            }
            me.aree.unshift({ text: "- Seleziona Area -", value: null });
        },
        loadDataAreaError(error) {
            console.log(error);
        },
        onClickAttivitaExtra(key) {
            let me = this;
            let item = {
                id: null,
                nomeAttivita: null,
                dataInizio: new Date().getTime(),
                dataFine: null,
                listaOrari: [{ dataInizio: new Date().getTime(), giorni: null, orari: null }],
                idAccettazione: this.pazienti[key].info.idAccettazione,
                idPaziente: this.pazienti[key].info.idAccettazione,
                area: { nome: this.filtro.area },
                dettaglio: "ATTIVITA EXTRA",
                rsaAttivitaPazienteBean: null,
                note: "Attivita Extra",
            };
            if (item.rsaAttivitaPazienteBean === null) {
                item.dataOraEffettuata = new Date().getTime();
            }
            me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(item, "ESEGUITA");
        },
        loadPiani() {
            let me = this;
            me.loadDataResources(me.pathResourcePiani, { idPresidio: me.idPresidio }, this.loadPianiSuccess, null);
        },
        loadPianiSuccess(response) {
            let me = this;
            me.pianiOptions = response.data.data.list;
            me.pianiOptions.unshift({ nome: "- Seleziona Piano -", id: null });
        },
    },
};
</script>

<style lang="scss" scoped>
.ft-style-span {
    width: 100% !important;
}
</style>
